import { baseURL } from "./base-services.request";

export function getLoginRedirectURL(social: string) {
  return baseURL + "/v2/clients/login/" + social;
}
